<template>
  <div class="header" :isSoundOn="isSoundOn">
    <div class="wrapper">
      <a
        target="_blank"
        class="header__logo header__logo--main"
        :href="links.pikabu | randomizeLink"
      >
        <img src="./../assets/img/pikabu-logo-new.svg" width="98" height="38" />
      </a>
      <div class="header__row">
        <div class="header__sharer">
          <SharerFolding
            colored
            hoverScale
            :link="share.link"
            :text="share.text"
            :list="['vk', 'fb', 'ok', 'tw']"
            :pixels="share.pixels"
          />
        </div>
        <button
          class="header__sound"
          :class="{ 'header__sound--off': !isSoundOn }"
          type="button"
          aria-label="Включить/выключить звук"
          @click="toggleSound"
        >
          <svg-use v-if="isSoundOn" icon="sound-on" width="19" height="19" />
          <svg-use v-else icon="sound-off" width="23" height="19" />
        </button>
      </div>
      <a
        target="_blank"
        class="header__logo header__logo--sponsor"
        :href="links.ps | randomizeLink"
      >
        <img src="./../assets/img/ps-logo-new.svg" width="145" height="38" />
      </a>
    </div>
  </div>
</template>

<script>
import SharerFolding from "../classes/sharer/components/SharerFolding.vue";
import { mapState } from "vuex";

export default {
  components: {
    SharerFolding
  },
  data: function() {
    return {
      links: {
        pikabu:
          "https://ads.adfox.ru/260477/goLink?p1=cnpjl&p2=frfe&p5=jhivt&pr=%random%",
        ps:
          "https://ads.adfox.ru/260477/goLink?p1=cnpjl&p2=frfe&p5=jhivu&pr=%random%"
      },
      share: {
        link: "https://specials.pikabu.ru/ps5",
        text: "Это мир PlayStation 5. Математическая игра с любимыми героями.",
        pixels: {
          vk:
            "https://ads.adfox.ru/260477/getCode?p1=cnpjl&p2=frfe&pfc=dnchq&pfb=jhjcu&pr=%random%&ptrc=b",
          fb:
            "https://ads.adfox.ru/260477/getCode?p1=cnpjl&p2=frfe&pfc=dnchq&pfb=jhjcv&pr=%random%&ptrc=b",
          ok:
            "https://ads.adfox.ru/260477/getCode?p1=cnpjl&p2=frfe&pfc=dnchq&pfb=jhjcw&pr=%random%&ptrc=b",
          tw:
            "https://ads.adfox.ru/260477/getCode?p1=cnpjl&p2=frfe&pfc=dnchq&pfb=jhjdm&pr=%random%&ptrc=b"
        }
      },
      soundPixels: {
        on:
          "https://ads.adfox.ru/260477/getCode?p1=cnpjl&p2=frfe&pfc=dnchq&pfb=jhixt&pr=%random%&ptrc=b",
        off:
          "https://ads.adfox.ru/260477/getCode?p1=cnpjl&p2=frfe&pfc=dnchq&pfb=jhizq&pr=%random%&ptrc=b"
      }
    };
  },
  computed: {
    ...mapState(["isSoundOn"])
  },
  methods: {
    toggleSound() {
      if (this.isSoundOn) {
        this.$metrika.showPixel(this.soundPixels.off);
      } else {
        this.$metrika.showPixel(this.soundPixels.on);
      }

      this.$store.commit("toggleSound");
    }
  }
};
</script>

<style lang="scss">
.header {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  user-select: none;
  z-index: 50;

  .wrapper {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding-top: 11.5px;
    padding-bottom: 11.5px;
  }
}

.header__logo {
  display: block;
  position: relative;

  &--main {
    left: 3px;
    top: -1px;
  }

  img {
    display: block;
  }
}

.header__row {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-left: 48px;
  position: relative;
}

.header__sharer {
  pointer-events: all;
  display: block;
  width: 35px;
  height: 35px;
  margin: 0 5px;

  svg {
    width: 100%;
  }

  .sharer-folding {
    backface-visibility: hidden;
    transform: rotate(180deg);
    width: 100%;
    height: 100%;

    ._list {
      color: #fff;
      opacity: 0;
      transition: all 0.25s 0s ease;

      ._icon {
        transform: rotate(180deg);
      }
    }

    .sharer__button {
      color: $white;
      backface-visibility: hidden;
      transition: none;
      -webkit-tap-highlight-color: transparent;

      ._icon {
        &.-close {
          &:before,
          &:after {
            height: 1px;
          }
        }

        svg {
          transform: rotate(180deg);
        }
      }

      &:before {
        box-sizing: border-box;
        border: 1px solid currentColor;
        background-color: transparent;
        transition: all 0.5s 0s ease;
      }

      &:hover {
        color: $white;

        &:before {
          background-color: transparent;
        }
      }
    }

    .sharer__item {
      color: $white;
    }

    &.sharer--opened {
      ._list {
        opacity: 1;
      }

      .sharer__item {
        &:nth-child(1) {
          transform: translateX(calc(100% + 10px)) scale(1);
        }

        &:nth-child(2) {
          transform: translateX(calc(200% + 20px)) scale(1);
        }

        &:nth-child(3) {
          transform: translateX(calc(300% + 30px)) scale(1);
        }

        &:nth-child(4) {
          transform: translateX(calc(400% + 40px)) scale(1);
        }
      }
    }
  }
}

.header__sound {
  width: 35px;
  height: 35px;
  background-color: transparent;
  color: $white;
  position: relative;
  border-radius: 50%;
  border: none;
  padding: 8.5px;
  outline: none;
  margin: 0 5px;

  &:before {
    content: "";
    display: block;
    width: 100%;
    height: 100%;
    border: 1px solid $white;
    background-color: transparent;
    border-radius: 50%;
    position: absolute;
    top: 0;
    left: 0;
    transition: all 0.5s 0s ease;
  }

  &:hover {
    cursor: pointer;

    &:before {
      transform: scale(1.1);
    }
  }

  &--off {
    padding: 7px;

    svg {
      position: relative;
      top: 1px;
    }
  }
}

@media screen and (max-width: 440px) {
  .header {
    .wrapper {
      padding-right: 15px;
      padding-left: 15px;
    }
  }

  .header__logo {
    &--main {
      width: 76px;
      height: 24px;
      top: 2px;
      left: 0;
    }

    &--sponsor {
      width: 107px;
      height: 20px;
    }
  }

  .header__row {
    padding-left: 15px;
  }

  .header__sound {
    width: 30px;
    height: 30px;
  }

  .header__sharer {
    width: 30px;
    height: 30px;

    .sharer-folding.sharer--opened .sharer__item:nth-child(1) {
      transform: translateX(calc(100% + 30px)) translateY(-120%) scale(1);
    }

    .sharer-folding.sharer--opened .sharer__item:nth-child(2) {
      transform: translateX(calc(100% + -10px)) translateY(-120%) scale(1);
    }

    .sharer-folding.sharer--opened .sharer__item:nth-child(3) {
      transform: translateX(calc(100% + -50px)) translateY(-120%) scale(1);
    }

    .sharer-folding.sharer--opened .sharer__item:nth-child(4) {
      transform: translateX(calc(100% + -90px)) translateY(-120%) scale(1);
    }

    .sharer-folding.sharer--opened .sharer__item:nth-child(5) {
      transform: translateX(calc(100% + -130px)) translateY(-120%) scale(1);
    }
  }
}
</style>
